// extracted by mini-css-extract-plugin
module.exports = {"simpurchaseth":"SelectQuantity_simpurchaseth__lRh1B"};